<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button-goto ttText="new" ttGoto="list" [ttGotoParms]="{ list_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsLists" [ttBadge]="'badge'"></tt-list>
</tt-page>
